import { useDispatch } from 'react-redux';
import { setIsModalShowed } from '@yme/modals/actions';
import { MODALS } from '@yme/modals/constants';
export function useConfigurator(configuratorLeadFormPagePath) {
    const dispatch = useDispatch();
    const onConfiguratorHandler = () => {
        dispatch(setIsModalShowed({
            type: MODALS.CONFIGURATOR_MODAL,
            data: {
                configuratorLeadFormPagePath,
            },
        }));
    };
    return {
        onConfiguratorHandler,
    };
}
